export default {"src":"/_next/static/media/mercedes-benz-data-dashboard-logo-wortmarke.3a42ef13.svg","height":136,"width":193,"blurWidth":0,"blurHeight":0};